import React, { lazy, Suspense } from "react";
import "./App.css";
import "bootstrap/dist/js/bootstrap.bundle";
import "bootstrap/dist/css/bootstrap.min.css";
import Heading from "./Components/Heading";
import AboutUs from "./Components/AboutUs";
import Footer from "./Components/Footer";
import Preload from "./Components/Preload";
const Projects = lazy(() => import("./Components/Projects"));
const Contact = lazy(() => import("./Components/Contact"));
function App() {
  return (
    <div className="app">
      <Preload />
      <div className="main-app">
        <Heading />
        <Suspense
          fallback={<div style={{ textAlign: "center" }}>Loading...</div>}
        >
          <Projects />
        </Suspense>
        <AboutUs />
        <Suspense
          fallback={<div style={{ textAlign: "center" }}>Loading...</div>}
        >
          <Contact />
        </Suspense>
        <Footer />
      </div>
    </div>
  );
}

export default App;
